import { render, staticRenderFns } from "./PaymentValidationWaiting.vue?vue&type=template&id=79c3b619"
import script from "./PaymentValidationWaiting.vue?vue&type=script&lang=js"
export * from "./PaymentValidationWaiting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports